import React from 'react';

import { useParams } from 'react-router-dom';

import Record from 'ui/Record/Record';

import { CenteredCircularProgress } from 'components/Progress';

import NotFound from 'containers/Error/Pages/NotFound/NotFound';

import DataError from 'containers/Error/DataError';

import { isNotFound } from 'utils/api/errors';

import { useNavBarHeight } from 'utils/hooks/navbar';
import { useStore } from 'utils/hooks/store';

import EntityDetailsContent from 'components/Entities/EntityDetailsContent';

import EntityDetailsHeader from 'components/Entities/EntityDetailsHeader';
import EntitiesDetailsLoader from 'ui/DetailsLoader/EntitiesDetailsLoader';

const ContactsDetails: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const params = useParams<{ entityId: string }>();

  const { contactDetails } = useStore();

  return (
    <EntitiesDetailsLoader params={params} routeParam="entityId" store={contactDetails}>
      {({ isLoaded, error, reload }): React.ReactElement => {
        if (!isLoaded) {
          return <CenteredCircularProgress />;
        }
        if (contactDetails.details === undefined) {
          return <NotFound />;
        }
        if (error) {
          if (isNotFound(error)) {
            return <NotFound />;
          }
          return <DataError onReload={reload} />;
        }

        const contactName = contactDetails.getName(contactDetails.details);

        return (
          <Record
            navBarHeight={navBarHeight}
            Header={<EntityDetailsHeader store={contactDetails} title={contactName} />}
            Content={(onError) => <EntityDetailsContent onError={onError} store={contactDetails} />}
          />
        );
      }}
    </EntitiesDetailsLoader>
  );
};

export default ContactsDetails;
